import { render, staticRenderFns } from "./SharedCatalogs.vue?vue&type=template&id=040fb09b"
import script from "./SharedCatalogs.vue?vue&type=script&lang=js"
export * from "./SharedCatalogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports